/**
 * 2026 分院问卷表单与任务元数据（页面模块真源）。
 */

export const HOUSE_SURVEY_FORM_NAME = '分院问卷_2026';

export const HOUSE_SURVEY_TASK_KEY = '分院问卷_2026';

export const HOUSE_SURVEY_DISPLAY_DDL = '分院问卷_2026_展示';

export const HOUSE_SURVEY_OPEN_AT = '2026-07-03';

export const HOUSE_SURVEY_ACTION_URL = '/student/house/survey';
